import { validateChunkSize } from './common-validators';
export async function* streamFileChunksSequentially({ chunkSize, downloadChunk, }) {
    validateChunkSize(chunkSize);
    const buffer = new Uint8Array(chunkSize);
    let offset = 0n;
    while (true) {
        const dataReadSize = await downloadChunk(buffer, offset);
        if (dataReadSize === 0) {
            return;
        }
        yield buffer.slice(0, dataReadSize);
        if (dataReadSize < chunkSize) {
            return;
        }
        offset += BigInt(dataReadSize);
    }
}
